import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18next.use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: 'en',
    debug: false,
    resources: {
        "en": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Close",
            "discountAmount": "Discount amount",
            "downloadReceipt": "Download receipt (PDF)",
            "headerThankYou": "Thank you",
            "knowAboutUs": "Know about us",
            "leaveWishes": "Please leave your product wishes",
            "notNow": "Not now",
            "order": "Order",
            "paidAmount": "Paid amount",
            "pleaseWait": "Please wait while your transaction is being processed",
            "product": "Product",
            "purchaseDate": "Purchase date",
            "quantityAbrv": "Qty",
            "rate_shopping": "Please rate your shopping experience",
            "receipt": "Receipt",
            "receiptNotFound": "Sorry, we are unable to fetch your purchase transaction this time. Please try again later.",
            "remainingAmount": "Remaining amount",
            "responseThankYou": "Thank you for your response",
            "selflyTrademark": "This e-receipt service is enabled by Selfly Store - A Finnish company enabling merchants and consumers to meet over easy, convenient, and fun grab-and-go shopping experiences.",
            "send": "Send",
            "total": "Total",
            "totalCost": "Purchase total",
            "unitPrice": "Unit price",
            "vat": "VAT %",
            "vatAmount": "VAT amount",
            "completeTransactionFirst": "Please complete the remaining transaction and scan the QR code again.",
            "surchargeAmount": "Surcharge amount",
            "depositAmount": "Deposit amount",
            "deposit":"Deposit"
          }
        },
        "bg": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Затвори",
            "discountAmount": "Стойност на намалението",
            "downloadReceipt": "Свалете касова бележка (PDF)",
            "headerThankYou": "Благодарим Ви",
            "knowAboutUs": "Научете за нас",
            "leaveWishes": "Моля, оставете Вашите желани продукти",
            "notNow": "Не сега",
            "order": "Поръчай",
            "paidAmount": "Платена сума",
            "pleaseWait": "Моля, изчакайте докато Вашата транзакция се обработва",
            "product": "Продукт",
            "purchaseDate": "Дата на покупка",
            "quantityAbrv": "Количество",
            "rate_shopping": "Моля Ви, оценете Вашето пазаруване",
            "receipt": "Касова бележка",
            "receiptNotFound": "Извинявайте, в момента не можем да свалим Вашата транзакция. Моля, опитайте отново по-късно.",
            "remainingAmount": "Оставаща сума",
            "responseThankYou": "Благодарим за отговора",
            "selflyTrademark": "Тази услуга за електронни касови бележки се предоставя от Selfly Store - финландска компания, която дава възможност на търговците и потребителите да се срещат по време на лесно, удобно и забавно пазаруване от типа „вземи и си тръгни“.",
            "send": "Изпрати",
            "total": "Обща сума",
            "totalCost": "Обща сума на закупените стоки",
            "unitPrice": "Цена на единица",
            "vat": "ДДС %",
            "vatAmount": "Сума ДДС",
            "completeTransactionFirst": "Моля, завършете останалата транзакция и сканирайте QR кода отново.",
            "surchargeAmount": "Сума на надценката",
            "depositAmount": "Сума на депозита",
            "deposit": "Депозит"          
          }
        },
        "de": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Schließen",
            "discountAmount": "Rabattbetrag",
            "downloadReceipt": "Quittung herunterladen (PDF)",
            "headerThankYou": "Vielen Dank",
            "knowAboutUs": "Über uns",
            "leaveWishes": "Teilen Sie uns Ihre Produktwünsche mit.",
            "notNow": "Nicht jetzt.",
            "order": "Bestellen",
            "paidAmount": "Bezahlter Betrag",
            "pleaseWait": "Warten Sie, bis der Vorgang abgeschlossen ist.",
            "product": "Produkt",
            "purchaseDate": "Kaufdatum",
            "quantityAbrv": "Menge",
            "rate_shopping": "Bewerten Sie Ihren Einkauf.",
            "receipt": "Quittung",
            "receiptNotFound": "Wir konnten Ihren Kaufvorgang momentan leider nicht abrufen. Versuchen Sie es später noch einmal.",
            "remainingAmount": "Restbetrag",
            "responseThankYou": "Vielen Dank für Ihre Antwort.",
            "selflyTrademark": "Dieser E-Quittungsdienst wird von Selfly Store bereitgestellt, einem finnischen Unternehmen, das Verkäufer und Käufer über ein einfaches, bequemes und angenehmes Einkaufserlebnis zusammenbringt.",
            "send": "Senden",
            "total": "Summe",
            "totalCost": "Einkaufssumme",
            "unitPrice": "Einzelpreis",
            "vat": "MwSt. %",
            "vatAmount": "MwSt.-Betrag",
            "completeTransactionFirst": "Bitte führen Sie die verbleibende Transaktion aus und scannen Sie den QR-Code erneut.",
            "surchargeAmount": "Zuschlagsbetrag",
            "depositAmount": "Pfandbetrag",
            "deposit": "Einzahlung"        
          }
        },
        "es": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Cerrar",
            "discountAmount": "Importe del descuento",
            "downloadReceipt": "Descargar recibo (PDF)",
            "headerThankYou": "Gracias",
            "knowAboutUs": "Acerca de nosotros",
            "leaveWishes": "Indíquenos sus peticiones de productos",
            "notNow": "No ahora",
            "order": "Pedido",
            "paidAmount": "Importe pagado",
            "pleaseWait": "Espere mientras procesamos su transacción",
            "product": "Producto",
            "purchaseDate": "Fecha de compra",
            "quantityAbrv": "Cant.",
            "rate_shopping": "Puntúe su experiencia de compra",
            "receipt": "Recibo",
            "receiptNotFound": "Lo sentimos, en este momento no podemos completar la transacción de su compra. Inténtelo de nuevo más tarde.",
            "remainingAmount": "Importe restante",
            "responseThankYou": "Gracias por su respuesta",
            "selflyTrademark": "Servicio de recibo electrónico cortesía de Selfly Store, una compañía finlandesa que facilita el contacto entre comerciantes y consumidores y proporciona a estos experiencias de compra cómodas, divertidas e inmediatas.",
            "send": "Enviar",
            "total": "Total",
            "totalCost": "Total de la compra",
            "unitPrice": "Precio unitario",
            "vat": "% IVA",
            "vatAmount": "Importe IVA",
            "completeTransactionFirst": "Por favor complete la transacción restante y escanee el código QR de nuevo.",
            "surchargeAmount": "Importe del recargo",
            "depositAmount": "Importe del depósito",
            "deposit": "Depósito"       
          }
        },
        "et": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Sulge",
            "discountAmount": "Soodustuse summa",
            "downloadReceipt": "Kviitungi allalaadimine (PDF)",
            "headerThankYou": "Aitäh!",
            "knowAboutUs": "Meie kohta",
            "leaveWishes": "Palun jätke oma tootesoovid",
            "notNow": "Mitte praegu",
            "order": "Tellimus",
            "paidAmount": "Tasutud summa",
            "pleaseWait": "Palun oodake, kuni tehingut töödeldakse",
            "product": "Toode",
            "purchaseDate": "Ostu kuupäev",
            "quantityAbrv": "Kogus",
            "rate_shopping": "Palun hinnake oma ostukogemust",
            "receipt": "Kviitung",
            "receiptNotFound": "Kahjuks ei saa me seekord ostutehingut tuua. Proovige hiljem uuesti.",
            "remainingAmount": "Järelejäänud summa",
            "responseThankYou": "Täname vastuse eest",
            "selflyTrademark": "Seda e-kviitungi teenust pakub Selfly Store – Soome ettevõte, mis võimaldab kaupmeestel ja tarbijatel kohtuda lihtsa, mugava ja lõbusa ostlemiskogemuse teel.",
            "send": "Saada",
            "total": "Kokku",
            "totalCost": "Ost kokku",
            "unitPrice": "Ühikuhind",
            "vat": "KM%",
            "vatAmount": "Käibemaksu summa",
            "completeTransactionFirst": "Palun lõpetage allesjäänud tehing ja skannige QR-kood uuesti.",
            "surchargeAmount": "Lisatasu summa",
            "depositAmount": "Tagatisraha summa",
            "deposit": "Hoius" 
          }
        },
        "fi": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Sulje",
            "discountAmount": "Alennuksen määrä",
            "downloadReceipt": "Lataa kuitti PDF-tiedostona",
            "headerThankYou": "Kiitos",
            "knowAboutUs": "Tietoja meistä",
            "leaveWishes": "Kerro meille tuotetoiveistasi",
            "notNow": "Ei nyt",
            "order": "Tilaus",
            "paidAmount": "Maksettu summa",
            "pleaseWait": "Tapahtumaasi käsitellään, odota hetki",
            "product": "Tuote",
            "purchaseDate": "Ostopäivä",
            "quantityAbrv": "Määrä",
            "rate_shopping": "Arvioi ostokokemuksesi",
            "receipt": "Kuitti",
            "receiptNotFound": "Pahoittelut, emme pysty hakemaan ostotapahtumaasi juuri nyt. Yritä myöhemmin uudelleen.",
            "remainingAmount": "Jäljellä oleva summa",
            "responseThankYou": "Kiitos vastauksestasi",
            "selflyTrademark": "Tämän sähköisten kuittien palvelun tarjoaa Selfly Store. Se on suomalainen yritys, joka yhdistää kaupat ja kuluttajat toisiinsa helpoissa ja näppärän nopeissa ostokokemuksissa.",
            "send": "Lähetä",
            "total": "Yhteensä",
            "totalCost": "Oston kokonaissumma",
            "unitPrice": "Yksikköhinta",
            "vat": "ALV-%",
            "vatAmount": "ALV-summa",
            "completeTransactionFirst": "Ole hyvä ja suorita jäljellä oleva transaktio ja skannaa QR-koodi uudelleen.",
            "surchargeAmount": "Lisämaksun määrä",
            "depositAmount": "Panttimäärä",
            "deposit": "Talletus"
          }
        },
        "fr": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Fermer",
            "discountAmount": "Montant de la remise",
            "downloadReceipt": "Télécharger le reçu (PDF)",
            "headerThankYou": "Merci",
            "knowAboutUs": "À propos",
            "leaveWishes": "Veuillez indiquer vos souhaits de produits",
            "notNow": "Pas maintenant",
            "order": "Commander",
            "paidAmount": "Montant payé",
            "pleaseWait": "Veuillez patienter pendant le traitement de votre transaction",
            "product": "Produit",
            "purchaseDate": "Date d’achat",
            "quantityAbrv": "Qté",
            "rate_shopping": "Veuillez évaluer votre expérience d’achat",
            "receipt": "Reçu",
            "receiptNotFound": "Désolé, nous ne pouvons pas récupérer votre transaction d’achat cette fois-ci. Veuillez réessayer plus tard.",
            "remainingAmount": "Montant restant",
            "responseThankYou": "Merci pour votre réponse",
            "selflyTrademark": "Ce service de reçu électronique est offert par Selfly Store - Une société finlandaise permettant aux commerçants et aux consommateurs de se rencontrer autour d’expériences d’achat faciles, pratiques et amusantes.",
            "send": "Envoyer",
            "total": "Total",
            "totalCost": "Total d’achat",
            "unitPrice": "Prix unitaire",
            "vat": "TVA %",
            "vatAmount": "Montant de la TVA",
            "completeTransactionFirst": "Veuillez terminer la transaction restante et scanner à nouveau le code QR.",
            "surchargeAmount": "Montant de la majoration",
            "depositAmount": "Montant de la consigne",
            "deposit": "Dépôt"
          }
        },
        "hu": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Bezárás",
            "discountAmount": "Kedvezmény mértéke",
            "downloadReceipt": "Nyugta letöltése (PDF)",
            "headerThankYou": "Köszönjük",
            "knowAboutUs": "Ismerjen meg minket",
            "leaveWishes": "Kérjük, adja meg termékkívánságait",
            "notNow": "Most nem",
            "order": "Rendelés",
            "paidAmount": "Kifizetett összeg",
            "pleaseWait": "Kérjük, várjon a rendelés feldolgozásáig",
            "product": "Termék",
            "purchaseDate": "Vásárlás dátuma",
            "quantityAbrv": "Menny.",
            "rate_shopping": "Kérjük, értékelje vásárlási élményét",
            "receipt": "Nyugta",
            "receiptNotFound": "Sajnos jelenleg nem tudjuk lekérni a vásárlási tranzakcióját. Kérjük, próbálja újra később.",
            "remainingAmount": "Fennmaradó összeg",
            "responseThankYou": "Köszönjük válaszát",
            "selflyTrademark": "Ezt az e-nyugta-szolgáltatást a finn Selfly Store vállalat kínálja, amely lehetővé teszi a kereskedők és a fogyasztók közötti egyszerű, kényelmes és szórakoztató önkiszolgáló vásárlás közbeni találkozást.",
            "send": "Küldés",
            "total": "Összesen",
            "totalCost": "Vásárlás összesen",
            "unitPrice": "Egységár",
            "vat": "ÁFA %",
            "vatAmount": "ÁFA összege",
            "completeTransactionFirst": "Kérjük, fejezze be a fennmaradó tranzakciót, majd olvassa be újra a QR-kódot.",
            "surchargeAmount": "Felár összege",
            "depositAmount": "Betétdíj összege",
            "deposit": "Letét"
          }
        },
        "it": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Chiudi",
            "discountAmount": "Importo dello sconto",
            "downloadReceipt": "Scarica la ricevuta (PDF)",
            "headerThankYou": "Grazie",
            "knowAboutUs": "Su di noi",
            "leaveWishes": "Dicci quali prodotti vuoi",
            "notNow": "Non ora",
            "order": "Ordine",
            "paidAmount": "Importo pagato",
            "pleaseWait": "Attendi. La transazione è in corso di elaborazione",
            "product": "Prodotto",
            "purchaseDate": "Data di acquisto",
            "quantityAbrv": "Q.tà",
            "rate_shopping": "Valuta la tua esperienza di acquisto",
            "receipt": "Ricevuta",
            "receiptNotFound": "Siamo spiacenti, ma non è stato possibile recuperare la transazione di acquisto. Ritenta più tardi.",
            "remainingAmount": "Importo residuo",
            "responseThankYou": "Grazie per la tua risposta",
            "selflyTrademark": "Questo servizio di ricevuta elettronica è reso possibile da Selfly Store, una società finlandese che consente a commercianti e consumatori di incontrarsi in esperienze di acquisto “prendi e via” facili, pratiche e divertenti.",
            "send": "Invia",
            "total": "Totale",
            "totalCost": "Totale acquisto",
            "unitPrice": "Prezzo unitario",
            "vat": "IVA %",
            "vatAmount": "Importo IVA",
            "completeTransactionFirst": "Per favore, completare la transazione restante e scansionare nuovamente il codice QR.",
            "surchargeAmount": "Importo del sovrapprezzo",
            "depositAmount": "Importo del deposito",
            "deposit": "Deposito"
          }
        },
        "lv": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Aizvērts",
            "discountAmount": "Atlaides summa",
            "downloadReceipt": "Lejupielādēt čeku (PDF)",
            "headerThankYou": "Paldies",
            "knowAboutUs": "Uzziniet par mums",
            "leaveWishes": "Lūdzu, atstājiet informāciju par savām produktu vēlmēm",
            "notNow": "Ne tagad",
            "order": "Pasūtījums",
            "paidAmount": "Samaksātā summa",
            "pleaseWait": "Lūdzu, pagaidiet, kamēr tiek apstrādāts jūsu darījums",
            "product": "Produkts",
            "purchaseDate": "Pirkuma datums",
            "quantityAbrv": "Daudzums",
            "rate_shopping": "Lūdzu, novērtējiet savu iepirkšanās pieredzi",
            "receipt": "Kvīts",
            "receiptNotFound": "Atvainojiet, mēs nevaram saņemt jūsu pirkuma darījumu šajā laikā. Lūdzu, mēģiniet vēlreiz vēlāk.",
            "remainingAmount": "Atlikusī summa",
            "responseThankYou": "Paldies par atbildi",
            "selflyTrademark": "Šo e-kvīts pakalpojumu nodrošina Selfly Store - Somijas uzņēmums, kas ļauj tirgotājiem un patērētājiem satikties, izmantojot vienkāršu, ērtu un jautru \"grab-and-go\" iepirkšanās pieredzi.",
            "send": "Nosūtīt",
            "total": "Kopā",
            "totalCost": "Pirkuma kopsumma",
            "unitPrice": "Vienības cena",
            "vat": "PVN %",
            "vatAmount": "PVN summa",
            "completeTransactionFirst": "Lūdzu, pabeidziet atlikušo darījumu un vēlreiz skenējiet QR kodu.",
            "surchargeAmount": "Piemaksas summa",
            "depositAmount": "Depozīta summa",
            "deposit": "Noguldījums"   
          }
        },
        "no": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Lukk",
            "discountAmount": "Tilbudsbeløp",
            "downloadReceipt": "Last ned kvittering (PDF)",
            "headerThankYou": "Takk",
            "knowAboutUs": "Bli kjent med oss",
            "leaveWishes": "Legg igjen produktønskene dine",
            "notNow": "Ikke akkurat nå",
            "order": "Bestilling",
            "paidAmount": "Betalt beløp",
            "pleaseWait": "Vent",
            "product": "Produkt",
            "purchaseDate": "Betalingsdato",
            "quantityAbrv": "Ant",
            "rate_shopping": "Vurder shoppingopplevelsen din",
            "receipt": "Kvittering",
            "receiptNotFound": "Vi kunne ikke hente kjøpstransaksjonen denne gangen. Prøv på nytt senere.",
            "remainingAmount": "Gjenstående beløp",
            "responseThankYou": "Takk for svaret ditt",
            "selflyTrademark": "Denne e-kvitteringstjenesten er aktivert av Selfly Store – et finsk selskap som gjør det mulig for selgere og forbrukere å møtes over enkle, praktiske og artige ta-og-gå shoppingopplevelser.",
            "send": "Send",
            "total": "Tilsammen",
            "totalCost": "Kjøp tilsammen",
            "unitPrice": "Enhetspris",
            "vat": "Mva %",
            "vatAmount": "Mva-beløp",
            "completeTransactionFirst": "Vennligst fullfør gjenværende transaksjon og skann QR-koden på nytt.",
            "surchargeAmount": "Tilleggsbeløp",
            "depositAmount": "Pantbeløp",
            "deposit": "Innskudd"
          }
        },
        "ro": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Închideți",
            "discountAmount": "Sumă discount",
            "downloadReceipt": "Descărcați chitanța (PDF)",
            "headerThankYou": "Vă mulțumim",
            "knowAboutUs": "Aflați despre noi",
            "leaveWishes": "Vă rugăm să ne lăsați produsele dorite",
            "notNow": "Nu acum",
            "order": "Comandă",
            "paidAmount": "Sumă plătită",
            "pleaseWait": "Vă rugăm să așteptați cât timp tranzacția dumneavoastră este procesată",
            "product": "Produs",
            "purchaseDate": "Dată achiziție",
            "quantityAbrv": "Cant.",
            "rate_shopping": "Vă rugăm să evaluați experiența dumneavoastră de cumpărături",
            "receipt": "Chitanță",
            "receiptNotFound": "Ne pare rău, nu putem prelua tranzacția de cumpărare în acest moment. Vă rugăm să încercați din nou mai târziu.",
            "remainingAmount": "Sumă rămasă",
            "responseThankYou": "Vă mulțumim pentru răspuns",
            "selflyTrademark": "Acest serviciu de chitanță electronică este activat de Magazinul Selfly - o companie finlandeză care le permite comercianților și consumatorilor să se întâlnească prin experiențe de cumpărături simple, convenabile și distractive.",
            "send": "Trimiteți",
            "total": "Total",
            "totalCost": "Total achiziție",
            "unitPrice": "Preț unitar",
            "vat": "TVA %",
            "vatAmount": "Sumă TVA",
            "completeTransactionFirst": "Vă rugăm să finalizați tranzacția rămasă și să scanați codul QR din nou.",
            "surchargeAmount": "Suma suprataxei",
            "depositAmount": "Suma depozitului",
            "deposit": "Depozit"
          }
        },
        "sv": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Stäng",
            "discountAmount": "Rabattbelopp",
            "downloadReceipt": "Hämta kvitto (PDF)",
            "headerThankYou": "Tack",
            "knowAboutUs": "Lär känna oss",
            "leaveWishes": "Lämna dina produktönskemål",
            "notNow": "Inte nu",
            "order": "Order",
            "paidAmount": "Betalt belopp",
            "pleaseWait": "Vänligen vänta",
            "product": "Produkt",
            "purchaseDate": "Köpdatum",
            "quantityAbrv": "Kvt",
            "rate_shopping": "Betygsätt gärna din shoppingupplevelse",
            "receipt": "Kvitto",
            "receiptNotFound": "Vi kunde tyvärr inte hämta din köptransaktionen den här gången. Försök igen senare.",
            "remainingAmount": "Resterande belopp",
            "responseThankYou": "Tack för ditt svar",
            "selflyTrademark": "Den här e-kvittotjänsten drivs av Selfly Store – ett finskt företag som gör det möjligt för handlare och konsumenter att mötas i enkla, bekväma och roliga kontaktfria shoppingupplevelser.",
            "send": "Skicka",
            "total": "Totalt",
            "totalCost": "Totalbelopp",
            "unitPrice": "Enhetspris",
            "vat": "Moms %",
            "vatAmount": "Momsbelopp",
            "completeTransactionFirst": "Vänligen slutför den återstående transaktionen och skanna QR-koden igen.",
            "surchargeAmount": "Tilläggsbelopp",
            "depositAmount": "Pantbelopp",
            "deposit": "Insättning"
          }
        },
        "de-CH": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Schliessen",
            "discountAmount": "Rabattbetrag",
            "downloadReceipt": "Quittung herunterladen (PDF)",
            "headerThankYou": "Vielen Dank",
            "knowAboutUs": "Über uns",
            "leaveWishes": "Teilen Sie uns Ihre Produktwünsche mit.",
            "notNow": "Nicht jetzt.",
            "order": "Bestellen",
            "paidAmount": "Bezahlter Betrag",
            "pleaseWait": "Warten Sie, bis der Vorgang abgeschlossen ist.",
            "product": "Produkt",
            "purchaseDate": "Kaufdatum",
            "quantityAbrv": "Menge",
            "rate_shopping": "Bewerten Sie Ihren Einkauf.",
            "receipt": "Quittung",
            "receiptNotFound": "Wir konnten Ihren Kaufvorgang momentan leider nicht abrufen. Versuchen Sie es später noch einmal.",
            "remainingAmount": "Restbetrag",
            "responseThankYou": "Vielen Dank für Ihre Antwort.",
            "selflyTrademark": "Dieser E-Quittungsdienst wird von Selfly Store bereitgestellt, einem finnischen Unternehmen, das Verkäufer und Käufer über ein einfaches, bequemes und angenehmes Einkaufserlebnis zusammenbringt.",
            "send": "Senden",
            "total": "Summe",
            "totalCost": "Einkaufssumme",
            "unitPrice": "Einzelpreis",
            "vat": "MwSt. %",
            "vatAmount": "MwSt.-Betrag",
            "completeTransactionFirst": "Bitte schliesse die verbleibende Transaktion ab und scanne den QR-Code erneut.",
            "surchargeAmount": "Tilläggsbelopp",
            "depositAmount": "Pantbelopp",
            "surchargeAmount": "Zuschlagsbetrag",
            "depositAmount": "Pfandbetrag",
            "deposit": "Einzahlung"
          }
        },
        "da": {
          "translation": {
            cabinet: 'Selfly Store',
            close: 'Luk',
            discountAmount: 'Rabatbeløb',
            downloadReceipt: 'Download kvittering (PDF)',
            headerThankYou: 'Tak',
            knowAboutUs: 'Få mere at vide om os',
            leaveWishes: 'Skriv venligst dine produktønsker',
            notNow: 'Ikke nu',
            order: 'Bestilling',
            paidAmount: 'Betalt beløb',
            pleaseWait: 'Vent venligst, mens din transaktion behandles',
            product: 'Produkt',
            purchaseDate: 'Købsdato',
            quantityAbrv: 'Antal',
            rate_shopping: 'Bedøm venligst din indkøbsoplevelse',
            receipt: 'Kvittering',
            receiptNotFound: 'Beklager, vi er ikke i stand til at hente din købstransaktion denne gang. Prøv igen senere.',
            remainingAmount: 'Resterende beløb',
            responseThankYou: 'Tak for dit svar',
            selflyTrademark: 'Denne e-kvitteringstjeneste er leveret af Selfly Store - et finsk firma, der gør det muligt for handlende og forbrugere at mødes over nemme, bekvemme og sjove grab-and-go købsoplevelser.',
            send: 'Send',
            total: 'I alt',
            totalCost: 'Samlet køb',
            unitPrice: 'Pris pr. stk.',
            vat: 'Moms %',
            vatAmount: 'Momsbeløb',
            completeTransactionFirst: 'Gennemfør den resterende transaktion og scan QR-koden igen.',
            "surchargeAmount": "Tillægsbeløb",
            "depositAmount": "Pantbeløb",
            "deposit": "Indbetaling"
          }
        },
        "cs": {
          "translation": {
            "cabinet":'Kabinet Selfly Store "Samoobsluha"',
            "close":'Zavřít',
            "discountAmount":'Výše slevy',
            "downloadReceipt":'Stáhnout účtenku (PDF formát)',
            "headerThankYou":'Děkujeme',
            "knowAboutUs":'Vědět o nás',
            "leaveWishes":'Zanechte prosím své návrhy k produktům',
            "notNow":'Nyní nelze',
            "order":'Objednávka',
            "paidAmount":'Uhrazená částka',
            "pleaseWait":'Vaše transakce se zpracovává, vyčkejte prosím',
            "product":'Produkt',
            "purchaseDate":'Datum prodeje',
            "quantityAbrv":'Množství',
            "rate_shopping":'Prosím ohodnoťte váš nákup',
            "receipt":'Účtenka',
            "receiptNotFound":'Je nám líto, ale tentokrát nemůžeme načíst vaši nákupní transakci/účtenku. Prosím zkuste to znovu později.',
            "remainingAmount":'Zbývající částka',
            "responseThankYou":'Děkujeme za Vaši odpověď',
            "selflyTrademark":'Tuto službu elektronického účtenky umožňuje Selfly Store - finská společnost, která umožňuje obchodníkům a spotřebitelům setkávat se při snadném, pohodlném a zábavném nakupování.',
            "send":'Poslat',
            "total":'Celkem',
            "totalCost":'Nákup celkem',
            "unitPrice":'Jednotková cena',
            "vat":'DPH %',
            "vatAmount":'částka DPH',
            "completeTransactionFirst":'Prosím dokončete zbývající transakci a znovu naskenujte QR kód.',                 
            "surchargeAmount": "Částka příplatku",
            "depositAmount": "Částka zálohy",
            "deposit": "Vklad"
          }          
        },
        "pt": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Fechar",
            "discountAmount": "Valor do desconto",
            "downloadReceipt": "Baixar recibo (PDF)",
            "headerThankYou": "Obrigado",
            "knowAboutUs": "Saiba mais sobre nós",
            "leaveWishes": "Por favor, deixe seus desejos de produtos",
            "notNow": "Não agora",
            "order": "Pedido",
            "paidAmount": "Valor pago",
            "pleaseWait": "Por favor, aguarde enquanto sua transação está sendo processada",
            "product": "Produto",
            "purchaseDate": "Data da compra",
            "quantityAbrv": "Qtd",
            "rate_shopping": "Por favor, avalie sua experiência de compra",
            "receipt": "Recibo",
            "receiptNotFound": "Desculpe, não conseguimos recuperar sua transação de compra desta vez. Por favor, tente novamente mais tarde.",
            "remainingAmount": "Valor restante",
            "responseThankYou": "Obrigado pela sua resposta",
            "selflyTrademark": "Este serviço de e-receipt é habilitado pela Selfly Store - Uma empresa finlandesa que permite que comerciantes e consumidores se encontrem em experiências de compras fáceis, convenientes e divertidas.",
            "send": "Enviar",
            "total": "Total",
            "totalCost": "Total da compra",
            "unitPrice": "Preço unitário",
            "vat": "IVA %",
            "vatAmount": "Valor do IVA",
            "completeTransactionFirst": "Por favor, complete a transação restante e escaneie o código QR novamente.",
            "surchargeAmount": "Valor da sobretaxa",
            "depositAmount": "Valor do depósito",
            "deposit": "Depósito"   
          }
        },
        "tr": {
          "translation": {
              "cabinet": "Selfly Store",
              "close": "Kapat",
              "discountAmount": "İndirim tutarı",
              "downloadReceipt": "Makbuzu indir (PDF)",
              "headerThankYou": "Teşekkür ederiz",
              "knowAboutUs": "Hakkımızda bilgi edinin",
              "leaveWishes": "Lütfen ürün dileklerinizi iletin",
              "notNow": "Daha sonra",
              "order": "İşlem",
              "paidAmount": "Ödenen tutar",
              "pleaseWait": "İşleminiz gerçekleştirilirken lütfen bekleyin",
              "product": "Ürün",
              "purchaseDate": "Satın alma tarihi",
              "quantityAbrv": "Miktar",
              "rate_shopping": "Alışveriş deneyiminizi lütfen değerlendirin",
              "receipt": "E-makbuz",
              "receiptNotFound": "Üzgünüz, bu sefer satın alma işleminizi getiremiyoruz. Lütfen daha sonra tekrar deneyin.",
              "remainingAmount": "Kalan tutar",
              "responseThankYou": "Yanıtınız için teşekkür ederiz",
              "selflyTrademark": "Bu e-makbuz hizmeti, satıcıların ve tüketicilerin kolay, hızlı ve eğlenceli bir alışveriş deneyiminde buluşmasını sağlayan Finlandiya kökenli şirket olan Selfly Store tarafından sağlanmaktadır.",
              "send": "Gönder",
              "total": "Toplam",
              "totalCost": "Toplam",
              "unitPrice": "Birim fiyat",
              "vat": "KDV %",
              "vatAmount": "KDV tutarı",
              "completeTransactionFirst": "Lütfen işlemi tamamlayın ve QR kodunu tekrar tarayın.",
              "surchargeAmount": "Ek ücret miktarı",
              "depositAmount": "Depozito miktarı",
              "deposit": "Depozito"
          }
        },
        "nl": {
          "translation": {
            "cabinet": "Selfly Store",
            "close": "Sluiten",
            "discountAmount": "Kortingsbedrag",
            "downloadReceipt": "Bon downloaden (PDF)",
            "headerThankYou": "Dank u",
            "knowAboutUs": "Meer over ons",
            "leaveWishes": "Laat uw productwensen achter",
            "notNow": "Niet nu",
            "order": "Bestelling",
            "paidAmount": "Betaald bedrag",
            "pleaseWait": "Even geduld, uw transactie wordt verwerkt",
            "product": "Product",
            "purchaseDate": "Aankoopdatum",
            "quantityAbrv": "Aantal",
            "rate_shopping": "Beoordeel uw winkelervaring",
            "receipt": "Bon",
            "receiptNotFound": "Sorry, we kunnen uw aankooptransactie op dit moment niet ophalen. Probeer het later opnieuw.",
            "remainingAmount": "Resterend bedrag",
            "responseThankYou": "Bedankt voor uw reactie",
            "selflyTrademark": "Deze e-bonservice wordt aangeboden door Selfly Store - een Fins bedrijf dat verkopers en consumenten samenbrengt via eenvoudige, handige en leuke grab-and-go winkelervaringen.",
            "send": "Verzenden",
            "total": "Totaal",
            "totalCost": "Totaal aankoop",
            "unitPrice": "Eenheidsprijs",
            "vat": "BTW %",
            "vatAmount": "BTW-bedrag",
            "completeTransactionFirst": "Voltooi de resterende transactie en scan de QR-code opnieuw.",
            "surchargeAmount": "Toeslagbedrag",
            "depositAmount": "Statiegeldbedrag",
            "deposit": "Borg"
          }
        }
      }
});

export default i18next;